import * as React from "react";
import {
  GetOAuthSettings,
  UpdateOAuthSettings,
  UpdateADSettings,
  GetCredentialList
} from "../../../actions/OAuthActions";
import ADSettingsStore from "../../../stores/ADSettingsStore";
import actionTypes from "../../../actions/ActionTypes";
class ADOAuthSettingsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSettings: void 0,
      credentialList: []
    };
    this.onADSettingsUpdate = this.onADSettingsUpdate.bind(this);
    this.toggleEnableAD = this.toggleEnableAD.bind(this);
    this.toggleEnableOAuth = this.toggleEnableOAuth.bind(this);
    this.onEditLDAP = this.onEditLDAP.bind(this);
    this.onEditClientId = this.onEditClientId.bind(this);
    this.onEditClientSecret = this.onEditClientSecret.bind(this);
    this.onEditTenant = this.onEditTenant.bind(this);
    this.onEditCredential = this.onEditCredential.bind(this);
    this.saveOAuthSettings = this.saveOAuthSettings.bind(this);
    this.saveADSettings = this.saveADSettings.bind(this);
  }
  componentDidMount() {
    ADSettingsStore.addChangeListener(this.onADSettingsUpdate);
    GetOAuthSettings();
    GetCredentialList();
  }
  componentWillUnmount() {
    ADSettingsStore.removeChangeListener(this.onADSettingsUpdate);
  }
  onADSettingsUpdate() {
    console.log("error before?");
    let lastAction = ADSettingsStore.getLastChange();
    console.log("last action");
    console.log(lastAction);
    if (lastAction === actionTypes.UserGetADOauthSettings) {
      let settings = ADSettingsStore.getADSettings();
      this.setState({ currentSettings: settings });
    }
    if (lastAction === actionTypes.OAuthCredentialList) {
      let credentials = ADSettingsStore.getCredentialList();
      console.log("credentials");
      console.log(credentials);
      this.setState({ credentialList: credentials });
    }
  }
  onEditLDAP(e) {
    let settings = this.state.currentSettings;
    settings.ldapConnection = e.target.value;
    this.setState({ currentSettings: settings });
  }
  onEditClientId(e) {
    let settings = this.state.currentSettings;
    settings.clientId = e.target.value;
    this.setState({ currentSettings: settings });
  }
  onEditClientSecret(e) {
    let settings = this.state.currentSettings;
    settings.clientSecret = e.target.value;
    this.setState({ currentSettings: settings });
  }
  onEditTenant(e) {
    let settings = this.state.currentSettings;
    settings.tenantId = e.target.value;
    this.setState({ currentSettings: settings });
  }
  toggleEnableAD() {
    let cs = this.state.currentSettings;
    cs.enableAD = !cs.enableAD;
    this.setState({ currentSettings: cs });
  }
  toggleEnableOAuth() {
    let cs = this.state.currentSettings;
    cs.enableOAuth = !cs.enableOAuth;
    this.setState({ currentSettings: cs });
  }
  onEditCredential(e) {
    console.log(e.target.value);
    let cs = this.state.currentSettings;
    cs.credentialId = e.target.value;
    this.setState({ currentSettings: cs });
  }
  saveOAuthSettings() {
    UpdateOAuthSettings(this.state.currentSettings);
  }
  saveADSettings() {
    UpdateADSettings(this.state.currentSettings);
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container" }, this.state.currentSettings !== void 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        style: { maxWidth: "60%", margin: "12px" },
        id: "userInfo",
        className: "card"
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "22",
          height: "22",
          viewBox: "0 0 448 512"
        },
        /* @__PURE__ */ React.createElement("path", { d: "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z" })
      ), "  ", "Windows Active Directory"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "useADswitch" }, "Enable AD authentication"), /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-check-input",
          type: "checkbox",
          checked: this.state.currentSettings.enableAD,
          onChange: this.toggleEnableAD,
          id: "useADswitch"
        }
      )), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "36px", marginTop: "10px" } }, this.state.currentSettings.enableAD && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtLDAP", className: "form-label" }, "LDAP Connection String:"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          className: "form-control",
          id: "txtLDAP",
          value: this.state.currentSettings.ldapConnection,
          onChange: this.onEditLDAP,
          placeholder: "LDAP Connection String"
        }
      )), /* @__PURE__ */ React.createElement(
        "button",
        {
          style: { marginTop: "8px" },
          className: "btn btn-success btn-sm",
          onClick: this.saveADSettings
        },
        "Save"
      )))
    ), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, this.state.currentSettings !== void 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        id: "userInfo",
        className: "card",
        style: { maxWidth: "80%", margin: "12px" }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 448 512",
          width: "23",
          height: "23"
        },
        /* @__PURE__ */ React.createElement("path", { d: "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z" })
      ), "  ", "Microsoft 365 OAuth"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "useADswitch" }, "Enable Office 365 OAuth Authentication"), /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-check-input",
          type: "checkbox",
          checked: this.state.currentSettings.enableOAuth,
          onChange: this.toggleEnableOAuth,
          id: "useADswitch"
        }
      )), /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "36px", marginTop: "10px" } }, this.state.currentSettings.enableOAuth && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtClientId", className: "form-label" }, "Credentials"), /* @__PURE__ */ React.createElement(
        "select",
        {
          className: "form-select",
          value: this.state.currentSettings.credentialId,
          onChange: this.onEditCredential
        },
        /* @__PURE__ */ React.createElement("option", { value: "-1" }),
        this.state.credentialList.map((cred) => /* @__PURE__ */ React.createElement("option", { key: cred.id, value: cred.id }, cred.name))
      ))), /* @__PURE__ */ React.createElement(
        "button",
        {
          style: { marginTop: "8px" },
          className: "btn btn-success btn-sm",
          onClick: this.saveOAuthSettings
        },
        "Save"
      )))
    )), /* @__PURE__ */ React.createElement("div", { className: "col-6" })));
  }
}
export default ADOAuthSettingsView;
